<template>
  <div class="set_signature">
    <div class="sign_list">
      <div class="sign_item">
        <div class="sign_title">审核药师：</div>
        <div class="sign_name" @click="checkSign(0)">
					<div v-if="!signImg[0]">请选择</div>
					<img class="sign_img" v-else :src="signImg[0]" alt="">
          <img class="arrow_img" src="@/images/arrow_right.png" alt="" />
        </div>
      </div>
      <div class="sign_item">
        <div class="sign_title">调配药师/士：</div>
        <div class="sign_name" @click="checkSign(1)">
          <div v-if="!signImg[1]">请选择</div>
					<img class="sign_img" v-else :src="signImg[1]" alt="">
          <img class="arrow_img" src="@/images/arrow_right.png" alt="" />
        </div>
      </div>
      <div class="sign_item">
        <div class="sign_title">复核/发药药师：</div>
        <div class="sign_name" @click="checkSign(2)">
          <div v-if="!signImg[2]">请选择</div>
					<img class="sign_img" v-else :src="signImg[2]" alt="">
          <img class="arrow_img" src="@/images/arrow_right.png" alt="" />
        </div>
      </div>
    </div>
		<div class="submit_box">
			<div class="submit_btn" @click="submit">
				保存
			</div>
		</div>


    <div class="mask" v-if="showCheckBox">
      <div class="signature_entry_module trans">
        <div class="drug_title">
          <div class="signature_img">选择签名</div>
        </div>
				<div style="padding:0 20px">
          <div class="flex1 boxbox">
            <div class="name_title">账号昵称</div>
            <div class="sign_title">签名</div>
            <div style="width:20px"></div>
            <!-- <van-icon class="select_icon" color="#807af4" size="20" name="checked" /> -->
          </div>
					<div class="flex1 boxbox" @click="selectSign(item,index)" v-for="(item,index) in pharName" :key="index">
						<div class="doctor_name" :class="{select:selectIndex==index}">{{item.PharName}}</div>
						<div class="flex1">
              <img class="sign_img" :src="item.SignImg" alt="">
							<!-- <div class="signature_img" @click="selectSign(item,index)" :class="{select:selectIndex==index}">{{item.PharName}}</div> -->
						</div>
              <van-icon class="select_icon" v-if="selectIndex!=index" color="#cccccc" size="20" name="circle" />
              <van-icon class="select_icon" v-else color="#807af4" size="20" name="checked" />
					</div>
				</div>
        <div class="flex2 double_btns">
          <div @click="cancel">取消</div>
          <div @click="confirm">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetPharSignList,SaveSignType } from "@/utils/api";
import { Toast, Icon } from 'vant';
export default {
  data() {
    return {
			showCheckBox: false,
			selectIndex:null,
			pharName:[],
			pharCode:[],
			signImg:[],
			type:null
    };
  },
  methods: {
		//选择签名
		selectSign(item,index) {
			if(this.selectIndex==index){
				this.selectIndex = null
			}else{
				this.selectIndex = index
			}
			// this.signImg[0] = item.SignImg
		},
    //请选择
    checkSign(type) {
			this.type = type
			this.selectIndex = null
			this.showCheckBox = true;
			GetPharSignList({
				// shopId:localStorage.getItem('shopId')
				}).then(res=>{
				if(res.code==1){
					this.pharName = res.data
				}
			})
    },
    //取消
    cancel() {
			this.showCheckBox = false
		},
    //确定
    confirm() {
			this.showCheckBox = false
			
			if(this.selectIndex!=null){
				this.signImg[this.type] = this.pharName[this.selectIndex].SignImg
				this.pharCode[this.type] = this.pharName[this.selectIndex].PharCode
			}else{
				this.signImg[this.type] = ''
				this.pharCode[this.type] = ''
			}
		},
    //保存
    submit() {
			console.log(this.pharCode);
			SaveSignType({
				AuditCode:this.pharCode[0],//审核药师 ,
				DispensCode:this.pharCode[1],//调配药师 , ,
				ReviewCode:this.pharCode[2],//复核药师 ,
			}).then(res=>{
				if(res.code==1){
					Toast('保存成功')
					sessionStorage.setItem('keepIngPrescriptionDetail',true)
					// keepIngPrescriptionDetail
					// this.$router.replace({path:'/prescriptionDetail',query:{from_set_sign:true,InquiryId:this.$route.query.id}})
					this.$router.go(-1)
				}else{
					Toast(res.msg)
				}
			})
		},
  },
};
</script>
<style lang="scss" scoped >
.submit_box {
	position: absolute;
	bottom: 30px;
	height: 46px;
	width: 90%;
	box-sizing: border-box;
}
.submit_btn {
	background: #7e7bf2;
	color: #fff;
	text-align: center;
	width: 86%;
	line-height: 46px;
	border-radius: 23px;
	margin: auto;
	font-size: 18px;
}
.set_signature {
	padding: 30px 16px 0;
	box-sizing: border-box;
	height: 100%;
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
    z-index: 999;
  }
  .signature_entry_module {
    width: 310px;
    // height:315px;
    background: rgba(255, 255, 255, 1);
    border-radius: 15px;
		position: fixed;
		// padding: 0 20px 30px;
    padding-bottom: 30px;

    box-sizing: border-box;
    .drug_title {
      display: flex;
      height: 45px;
      background: #f1f1f1;
      border-radius: 15px 15px 0 0;
      font-size: 16px;
      color: rgba(51, 51, 51, 1);
      text-align: center;
      line-height: 45px;
      position: relative;
      .title_text {
        margin: auto;
        font-weight: bold;
      }
    }
    .name_title{

      font-size: 14px;
      color: #333;
      min-width: 80px;
      text-align: center;
    }
    .sign_title {
      font-size: 14px;
      color: #333;
      width: 80px;
      text-align: center;
    }
    .doctor_name {
      color: #333;
      font-size: 14px;
      min-width: 80px;
      text-align: center;
      font-weight: bold;
    }
    .sign_img {
      width:80px;
      height:35px;
    }
    .select_icon {
      // margin-left: auto;
    }
		.signature_img {
			font-size: 16px;
			color: #333;
      font-weight: bold;
      margin: auto;
		}
		.select {
			color: #807af4;
		}
    .boxbox {
			height: 56px;
			line-height: 56px;
      border-bottom: 1px solid #eee;
      padding-right: 10px;
    }
  }
}
.sign_item {
  display: flex;
  color: #bbb;
  font-size: 16px;
  height: 66px;
  line-height: 66px;
  border-bottom: 1px solid #eee;
  .sign_title {
    color: #333;
	}
	.sign_img {
		width:80px;
    height:35px;
	}
  .sign_name {
    margin-left: auto;
    display: flex;
    align-items: center;
    .arrow_img {
      width: 8px;
      height: 14px;
      display: inline-block;
      margin-left: 16px;
    }
  }
}
.double_btns {
  justify-content: center;
  margin-top: 39px;
}
.double_btns > div:first-child {
  width: 110px;
  height: 30px;
  border: 1px solid #807af4;
  border-radius: 15px;
  text-align: center;
  line-height: 30px;
  box-sizing: border-box;
  font-size: 15px;
  color: #807af4;
  margin-right: 20px;
}
.double_btns > div:last-child {
  width: 110px;
  height: 30px;
  background: #807af4;
  border-radius: 15px;
  text-align: center;
  line-height: 30px;
  box-sizing: border-box;
  font-size: 15px;

  color: rgba(255, 255, 255, 1);
}
</style>